import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
  selector: 'error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.css']
})
export class ErrorPopupComponent implements OnInit {

  errorHeader: string = '';
  errorBody: string = ''
  btnName: string = 'Reload';

  @Output() reloadData: EventEmitter<any> = new EventEmitter();
  @ViewChild('errorModal') public errorModal: ModalDirective;
  constructor() { }

  ngOnInit() {
  }

  showErrorPopup(_header: string,_body:string) {
    this.errorHeader = _header;
    this.errorBody = _body;
    this.errorModal.show();
  }

  dataEdited() {
    this.reloadData.emit();
    this.hideErrorModal();
  }

  hideErrorModal() {
    this.errorModal.hide();
  }
}
